import { useState, useEffect } from 'react'
import { isInvalidEmail } from './validateEmail'
import { isInvalidPhoneNumber } from './validatePhoneNumber'
import { isInvalidName } from './validateName'
import { useSelector } from 'react-redux'
import {
  selectEmailForPrefill,
  selectNameForPrefill,
  selectPhoneForPrefill,
} from '../features/azure-b2c/storage'

export const useEmailPhoneName = () => {
  const accountEmail = useSelector(selectEmailForPrefill)
  const accountUsername = useSelector(selectNameForPrefill)
  const accountPhone = useSelector(selectPhoneForPrefill)

  const [email, setEmail] = useState<string | undefined>(accountEmail ?? '')
  const [name, setName] = useState<string | undefined>(accountUsername ?? '')
  const [phone, setPhone] = useState<string | undefined>(accountPhone ?? '')
  const [notes, setNotes] = useState<string | undefined>('')

  const [emailError, setEmailError] = useState<string>()
  const [phoneError, setPhoneError] = useState<string>()
  const [nameError, setNameError] = useState<string>()

  useEffect(() => {
    setEmail(accountEmail ?? '')
    setName(accountUsername ?? '')
    setPhone(accountPhone ?? '')
  }, [accountEmail, accountUsername, accountPhone])

  const validateFields = () => {
    const _emailError = isInvalidEmail(email)
    const _phoneError = isInvalidPhoneNumber(phone)
    const _nameError = isInvalidName(name)

    setEmailError(_emailError)
    setPhoneError(_phoneError)
    setNameError(_nameError)

    return !_emailError && !_phoneError && !_nameError
  }

  const reset = () => {
    setEmail(accountEmail ?? '')
    setName(accountUsername ?? '')
    setPhone(accountPhone ?? '')
    setNameError(undefined)
    setEmailError(undefined)
    setPhoneError(undefined)
  }

  const clearErrors = () => {
    setNameError(undefined)
    setEmailError(undefined)
    setPhoneError(undefined)
  }

  return {
    email,
    setEmail,
    name,
    setName,
    phone,
    setPhone,
    notes,
    setNotes,
    emailError,
    setEmailError,
    phoneError,
    setPhoneError,
    nameError,
    setNameError,
    validateFields,
    clearErrors,
    reset,
  }
}
